module.exports = __webpack_public_path__ + "static/media/applyStudent.929728c7.xlsx";